import logo from './logo.svg';
import './App.css';
import 'rsuite/dist/rsuite-no-reset.min.css';
import { Routes, Route, Link } from 'react-router-dom';
import Dashboard from './components/dashboard/Dashboard';
import CreateProject from './components/createProject/CreateProject';
import { useContext, createContext, useState, useEffect } from 'react';
import { userContext } from './contexts/userContext';
import { CookiesProvider, useCookies } from 'react-cookie';
import Header from './components/Header';
import Project from './components/project/Project';
import { Projects } from './components/projects/Projects';
import Clients from './components/clients/Clients';
import Client from './components/clients/Client';
import Login from './components/user/Login';

function App() {

  //const userContext = createContext();
  const [cookies, setCookie, removeCookie] = useCookies(['user_id']);
  const [user, setUser] = useState();

  const updateUser = (id) => {
    setUser(id);
  }

  const login = () => {
    updateUser(1);
  }

  const logout = () => {
    updateUser("")
    removeCookie('user_id');
  }

  useEffect(() => {
    if (user){
      setCookie('user_id', user)
    }
  },[user])



 console.log(cookies.user_id)
  return (
    <div className="flex justify-center items-center h-screen">
    { cookies.user_id=="none"||cookies.user_id==undefined ?
      <div className="flex m-auto">
        {/* <button onClick={login}>login</button> */}
        <Login updateUser={updateUser}/>
      </div>
        :
      <userContext.Provider value={[cookies.user_id, logout]}>
        <div className="App h-full w-100vw flex flex-col">
          <div className="">
            <Header logout={logout}/>
          </div>
          <div className="h-full">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="createproject" element={<CreateProject />} />
              <Route path="projects" element={<Projects />} />
              <Route path="project" element={<Project />} />
              <Route path="clients" element={<Clients />} />
              <Route path="client" element={<Client />} />
            </Routes>
          </div>
            
            
        </div>
      </userContext.Provider>
    }
    </div>
  );
}

export default App;